"use strict";

import angular from "angular";

import { Events } from "../../../presentation/services/Events/Events";

export class PopUpOnboardingStepsDialogCtrl {
    currentStep = {};
    page = 0;
    button = {
        label: "Próximo"
    };
    constructor(locals, $mdDialog) {
        this.locals = locals;

        this.$mdDialog = $mdDialog;
        this.steps = locals.steps;

        this.Events = new Events();
    }

    $onInit() {
        this.currentStep = this.steps[0];
    }

    onChangeStep(status) {
        switch (status) {
            case "next":
                this.Events.send(
                    `Popup.Onboarding.Steps.${this.steps[this.page].event}`
                );

                if (this.page === this.steps.length - 1) {
                    this.$mdDialog.hide();
                    this.page = 0;
                    return;
                }
                this.page =
                    this.page >= this.steps.length - 1
                        ? this.steps.length - 1
                        : this.page + 1;

                if (this.page === this.steps.length - 1) {
                    this.button.label = "Fechar";
                }
                this.currentStep = this.steps[this.page];

                break;
            case "back":
                this.page = this.page <= 0 ? 0 : this.page - 1;

                this.currentStep = this.steps[this.page];
                this.button.label = "Próximo";
                break;
        }
    }
}

angular.module("nucont.shared").controller("PopUpOnboardingStepsDialogCtrl", [
        "locals",
        "$mdDialog",
        PopUpOnboardingStepsDialogCtrl
    ]);
